import { InjectionToken } from '@angular/core';
import {
    BarCacheStore,
    BarCacheStoreOptions,
    BarCacheEntryOptions
} from '@lvflanders/bar';

/** Options for the cacheable decorator. */
export class BarCacheableOptions {
    /** Key to use to store in the cache store. */
    key?: string;
    /** Store options to determine which store to use or injection token to get the store from the DI container. */
    store?: InjectionToken<BarCacheStore> | BarCacheStoreOptions;
    /** Options to determine how to store the entry in the cache. */
    options?: BarCacheEntryOptions;
    /** Whether to use a promise instead of an Observable. The reason is that we cannot guess the return type by default without executing it. */
    promise? = false;
}
